module.exports = __webpack_public_path__ + "static/media/hp_03.3d85cfe8.jpg";